import React from "react";
import { STATUS_STYLES } from "../constants";

export default function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || { bg: "#34302A", text: "#B0A899", label: status };
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold tracking-tight whitespace-nowrap"
      style={{ backgroundColor: s.bg, color: s.text }}
    >
      {s.label}
    </span>
  );
}
